import 'vendor/bootstrap/tooltip';
import 'vendor/bootstrap/popover';
const Cookies = require('js-cookie');

const VidioHelpers = {
  debounce: function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    return function() {
      context = this;
      args = arguments;
      timestamp = new Date();
      var later = function() {
        var last = (new Date()) - timestamp;
        if (last < wait) {
          timeout = setTimeout(later, wait - last);
        } else {
          clearTimeout(timeout);
          timeout = null;
          if (!immediate) { result = func.apply(context, args); }
        }
      };
      var callNow = immediate && !timeout;
      if (!timeout) {
        timeout = setTimeout(later, wait);
      }
      if (callNow) { result = func.apply(context, args); }
      return result;
    };
  },

  formatDuration: function(parentSelector){
    var durationSelectors = $(parentSelector).find('span.video-duration');
    $(durationSelectors).each(function(index, selector){
      var second = $(selector).text();
      var time = this.secondToMinutes(second);
      $(selector).text(time);
    }.bind(this));
  },

  secondToMinutes: function(second) {
    var sec_num = parseInt(second, 10);
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (hours == '00')
      hours = '';
    else
      hours = hours + ':';

    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}

    var time    = hours+minutes+':'+seconds;
    return time;
  },

  timeToSeconds: function(timeString) {
    var timeArray = timeString.split(':');
    var timeMultiplier = [3600, 60, 1];

    var temp;
    var result = 0;
    var tempNumber;
    temp = timeArray.pop();
    while(temp !== undefined) {
      tempNumber = parseInt(temp);
      result += tempNumber * timeMultiplier.pop();
      temp = timeArray.pop();
    }

    return result;
  },

  isEmptyObject: function(obj){
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  },

  loginPopover: function($linkSelector, $templateSelector, $popoverContainer, $placement) {
    $popoverContainer = $popoverContainer || 'body';
    $placement = $placement || 'bottom';

    $linkSelector.popover({
      container: $popoverContainer,
      content: $templateSelector.html(),
      html: true,
      placement: $placement,
      trigger: 'manual'
    }).on('click', function(e) {
      e.preventDefault();
      $linkSelector.not(this).popover('hide');
      $(this).popover('toggle');
      e.stopPropagation();
    });
  },

  rangeDatePicker: function(startTimeSelector, endTimeSelector){
    var $startTime = $(startTimeSelector);
    var $endTime = $(endTimeSelector);

    $startTime.datepicker({
      defaultDate: "-2m",
      dateFormat: 'yy-mm-dd',
      changeMonth: true,
      numberOfMonths: 3,
      onClose: function( selectedDate ) {
        $endTime.datepicker( "option", "minDate", selectedDate );
      }
    });

    $endTime.datepicker({
      defaultDate: "-2m",
      dateFormat: 'yy-mm-dd',
      changeMonth: true,
      numberOfMonths: 3,
      onClose: function( selectedDate ) {
        $startTime.datepicker( "option", "maxDate", selectedDate );
      }
    });
  },

  validateDateRangeDays: function(startDateSelector, endDateSelector, daysLimit){
    var fromDate = this.getDate(startDateSelector);
    var toDate = this.getDate(endDateSelector);

    if (fromDate && toDate) {
      var days = (toDate - fromDate) / (24 * 60 * 60 * 1000);
      if (days > daysLimit) {
        window.alert('Please choose a time frame not longer than '+daysLimit+' days');
        return false;
      }
    } else if (fromDate || toDate) {
      window.alert('Please set both time frame');
      return false;
    }
  },

  getDate: function(dateSelector){
    return $(dateSelector).datepicker("getDate");
  },

  getReferrer: function() {
    return document.referrer;
  },

  rangeDateTimePicker: function(startTimeSelector, endTimeSelector) {
    var startTime = $(startTimeSelector);
    var endTime = $(endTimeSelector);
    var timeElements = {
      start: startTime,
      end: endTime
    };

    startTime.datetimepicker({
      dateFormat: 'yy-mm-dd',
      timeFormat: 'HH:mm',
      onClose: function(dateText) {
        this.onDateTimePickerCloseCallback(timeElements, 'end', dateText);
      }.bind(this),
      onSelect: function() {
        endTime.datetimepicker('option', 'minDate', startTime.datetimepicker('getDate'));
      }
    });

    endTime.datetimepicker({
      dateFormat: 'yy-mm-dd',
      timeFormat: 'HH:mm',
      onClose: function(dateText) {
        this.onDateTimePickerCloseCallback(timeElements, 'start', dateText);
      }.bind(this),
      onSelect: function (){
        startTime.datetimepicker('option', 'maxDate', endTime.datetimepicker('getDate') );
      }
    });
  },

  onDateTimePickerCloseCallback: function(elements, periodType, dateText) {
    if (elements[periodType].val() !== '') {
      var testStartTime = elements.start.datetimepicker('getDate');
      var testEndTime = elements.end.datetimepicker('getDate');
      if (testStartTime > testEndTime) {
        var testTime = periodType === 'start' ? testEndTime : testStartTime;
        elements[periodType].datetimepicker('setDate', testTime);
      }
    } else {
      elements[periodType].val(dateText);
    }
  },

  initSelect2: function(inputSelector, url, dataKey, labelKey, extraAjaxData, minLength, extraOptions) {
    var $input = $(inputSelector);
    var minInputLength = minLength || 3;
    var select2Options = {
      minimumInputLength: minInputLength,
      query: this.debounce(function(options) {
        $.ajax({
          url: url,
          type: "GET",
          data: this.select2AjaxData(options, extraAjaxData),
          success: function(pagination) {
            var more = pagination.current_page < pagination.last_page;
            var results = $.map(pagination, function(d) {
              var text;
              var textUsername = d.username ? ` (${ d.username })` : '';
              if(d.class_name != undefined) {
                text = d.class_name + ": " + d[labelKey] + textUsername;
              } else {
                text = d[labelKey] + textUsername;
              }
              return {  id: d.id, text: text };
            });
            options.callback({ more: more, results: results });
          }
        });
      }.bind(this), 300),
      initSelection: function(el, callback) {
        var data = $(el).data(dataKey);
        if(data.id !== null) {
          callback(data);
          if(!$input.val()) {
            $input.val(data.id);
          }
        }
      }
    };

    select2Options = Object.assign(select2Options, extraOptions);
    $input.select2(select2Options);
  },

  flexSelect2TextParser: function(object, label){
    var labels = label.split(',');
    var texts = [];
    for(var i=0; i < labels.length; i++){
      if(i == 0){
        texts.push(object[labels[i]]);
      }
      else{
        texts.push("(" + object[labels[i]] + ")");
      }
    }
    return texts.join(" ");
  },

  initFlexSelect2: function(inputSelector, url, dataKey, labelKey, extraAjaxData, minLength, extraOptions) {
    var $input = $(inputSelector);
    var minInputLength = minLength || 3;
    var select2Options = {
      minimumInputLength: minInputLength,
      query: this.debounce(function(options) {
        $.ajax({
          url: url,
          type: "GET",
          data: this.select2AjaxData(options, extraAjaxData),
          success: function(pagination) {
            var more = pagination.current_page < pagination.last_page;
            var results = $.map(pagination, function(d) {
              var text;
              text = this.flexSelect2TextParser(d, labelKey);
              return {  id: d.id, text: text };
            }.bind(this));
            options.callback({ more: more, results: results });
          }.bind(this)
        });
      }.bind(this), 300),
      initSelection: function(el, callback) {
        var data = $(el).data(dataKey);
        if(data.id !== null) {
          callback(data);
          if(!$input.val()) {
            $input.val(data.id);
          }
        }
      }
    };

    select2Options = Object.assign(select2Options, extraOptions);
    $input.select2(select2Options);
  },

  select2AjaxData: function(options, extraData) {
    var data = {'with_name': options.term, 'page': options.page};

    if (extraData) {
      var keys = Object.keys(extraData);
      keys.forEach(function(key) {
        data[key] = extraData[key];
      });
    }

    return data;
  },

  isCategoryPage: function() {
    return this.pathname().match(/^\/categories\//) ? true : false;
  },

  isEmbedVideo: function() {
    return this.pathname().match(/^\/embed\//) ? true : false;
  },

  isEmbedLivestreaming: function() {
    return this.pathname().match(/^\/live\/[0-9a-zA-Z-]+\/embed/) ? true : false;
  },

  isMobile: function() {
    return this.hostname().match(/^m\./) ? true : false;
  },

  isDesktop: function() {
    return !this.isMobile();
  },

  userAgent: function(){
    return navigator.userAgent;
  },

  isAndroid: function() {
    return this.userAgent().indexOf('Android') > -1;
  },

  isOperaMini: function() {
    return this.userAgent().indexOf('Opera Mini') > -1;
  },

  isIpad: function() {
    return this.userAgent().indexOf("iPad") > -1;
  },

  isIos: function() {
    return this.userAgent().indexOf("iPhone") > -1 || this.userAgent().indexOf("iPod") > -1 || this.isIpad();
  },

  isPremiumUser: function(){
    return Cookies.get('_vidio') === 'true';
  },

  getPlatform: function() {
    return this.isMobile() ? 'web-mobile' : 'web-desktop';
  },

  _getComputedStyle(el, property) {
    return window.getComputedStyle(el, null).getPropertyValue(property);
  },

  getComputedStyle: function(el, property) {
    return el ? this._getComputedStyle(el, property) : undefined;
  },

  showMessageForVidioApp: function(videoId, $videoPlayerSelector, humanizeMessage) {
    let message;

    message = this.errorMessageForWeb(videoId,humanizeMessage);
    $videoPlayerSelector.html(message);
  },

  errorMessageForWeb: function(videoId, humanizedMessage){
    let message =  '<div class="player-error__section">';
    message += '<div class="player-error__header">';
    message += '<h3 class="player-error__title">Error encountered</h3>';
    message += humanizedMessage;
    message += '</div>';
    message += '<a href="market://details?id=com.vidio.android"><div class="player-error__google-play"></div></a>';
    message += '<div class="player-error__play-on-app"><a href="vidio://watch.vidio.com/video/' + videoId + '">';
    message += 'If you already have Vidio Apps, please <span class="player-error__play-on-app--span">click here</span> to watch this video';
    message += '</div></a></div>';
    return message;
  },

  bindExportButton: function(form, reportButton){
    $(form).find(reportButton).click(function(){
      var path = $(this).data("path");
      var data = $(form).serialize();
      var url = path + "?" + data;
      window.location.href = url;
      return false;
    });
  },

  imageUpload: function($imageField, preview, $thumbnail) {
    $imageField.on("change", function(){
      var img = $(this);

      if(img.val() !== '') {
        var reader = new FileReader();
        var image  = new Image();

        var files = img.prop('files');
        var file  = files[0];
        reader.readAsDataURL(file);

        reader.onload = function(f) {
          image.src = f.target.result;
        };

        image.onload = function(){
          var imagePreview = document.getElementById(preview);
          if(imagePreview === null) {
            imagePreview = $thumbnail;
          }
          $(imagePreview).attr('src', this.src).css('display', 'block');
        };
        image.onerror = function() {
          window.alert('Invalid file type: ' + file.type);
        };
      }
    });
  },

  humanFileSize: function(bytes, si) {
    var thresh = si ? 1000 : 1024;

    if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    var units = si ? ['kB','MB','GB','TB','PB','EB','ZB','YB'] : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
    var u = -1;

    do {
      bytes /= thresh;
      ++u;
    } while(Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1)+' '+units[u];
  },

  reinitSlick: function(selector, options){
    $(selector).slick("unslick");
    $(selector).slick(options);
  },

  hostname: function(){
    return location.hostname;
  },

  pathname: function(){
    return location.pathname;
  },

  page_url: function(){
    return location.href;
  },

  generateId: function() {
    return this._generateId(new Date().getTime(), Math.random);
  },

  _generateId: function(d, randomFunction){
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + randomFunction()*16)%16 | 0;
        d = Math.floor(d/16);
        return (c=='x' ? r : (r&0x3|0x8)).toString(16);
    });
    return uuid;
  },

  isLoggedIn: function(){
    let $currentUsername = $('meta[name="current-username"]');
    return typeof($currentUsername.attr("content")) !== 'undefined' && $currentUsername.attr("content") !== "";
  },

  inViewPort: function(element) {
    var scrollPos = this.window().scrollY;
    var bottomPos = scrollPos + this.window().innerHeight;
    var elementTopPos = element.offsetTop;
    var elementBottomPos = element.offsetTop + element.offsetHeight;

    return (bottomPos > elementTopPos && elementTopPos > scrollPos) ||
      (bottomPos > elementBottomPos && elementBottomPos > scrollPos) ||
      (scrollPos > elementTopPos && bottomPos < elementBottomPos);
  },

  getLang: function() {
    var lang = $('meta[name=language]').attr('content');
    return lang === undefined ? 'id' : lang;
  },

  getExperiment: function() {
    if (typeof window.variantOption === 'undefined') {
      window.variantOption = ["1", "1", "0", "0"];
    }
    var choosenVariant = Math.floor(Math.random() * window.variantOption.length);
    return window.variantOption[choosenVariant];
  },

  getQueryParameter: function(locationString, paramName) {
    let newParamName = paramName.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + newParamName + '=([^&#]*)');
    let results = regex.exec(locationString);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },

  getDanaBalance: function(callback) {
    $.ajax({
      url: '/dashboard/dana_accounts/profile',
      dataType: 'json',
      method: 'GET'
    }).done(function(data) {
      callback(data);
    });
  },

  window: function(){
    return window;
  }
};

const helpers = {
  block: function(el) {
    $(el).block({
      message: window.Config.ImageUploader,
      css: {
        'border-radius': '4px',
        opacity: 0.8,
        border: 'none',
        display: 'block',
        padding: '10px',
        margin: '0 auto',
        width: '64px',
        height: '68px'
      }
    });
  },
  unblock: function(el) {
    $(el).unblock();
  },
  formatFileSize: function(size) {
    var i = Math.floor( Math.log(size) / Math.log(1024) );
    return ( size / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
  },

  hoverOverlay: function(selector) {
    $(selector).on('mouseenter', function() {
      $(this).find('.overlay').show();
    });
    $(selector).on('mouseleave', function() {
      $(this).find('.overlay').hide();
    });
  },

  parameterize: function(string) {
    var stripped_string = string.toLowerCase().replace(/[^a-z0-9.]/gi, '-');
    var stripped_multiple_separator = stripped_string.replace(/-{2,}/g, '-');
    var stripped_trailing_separator = stripped_multiple_separator.replace(/^-|-$/g, '');

    return stripped_trailing_separator;
  },

};

const HTMLHelper = {
  renderCode: function(parent, htmlCode) {
    const leadingWhitespaceTrimmed = htmlCode.replace(/^\s+/mg, "");
    const trailingWhitespaceTrimmed = leadingWhitespaceTrimmed.replace(/\s+$/mg, "")
    const lineBreakTrimmed = trailingWhitespaceTrimmed.replace(/(\r\n|\n|\r)/gm, "");
    parent.innerHTML = lineBreakTrimmed;
  }
}

export { VidioHelpers, helpers, HTMLHelper };
